// ============================================================================
// API Configuration
// ============================================================================

export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL || "http://localhost:3001",
  TIMEOUT: 10000,
} as const;

// ============================================================================
// Feature Flags
// ============================================================================

// Issue #131: strategy performance/AUM artifact stats are disputed by the
// strategy owner pending an exporter fix + restatement. PO decision: hide
// return and AUM figures from the /strategies catalog UI until the data is
// corrected and re-validated. Flip back to `true` after the restatement
// lands — this is the single switch that reverses the whole change.
export const SHOW_STRATEGY_PERFORMANCE = false;

// ============================================================================
// Navigation
// ============================================================================

export const NAV_LINKS = [
  { href: "/strategies", label: "Strategies" },
  { href: "/trade", label: "Trade" },
  { href: "/portfolio", label: "Portfolio" },
];

export const FOOTER_LINKS = [
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/terms", label: "Terms of Service" },
  { href: "/docs", label: "Documentation" },
];

export const ROUTE_PAGE_NAMES: Record<string, string> = {
  "/": "homepage",
  "/strategies": "strategies",
  "/trade": "trade",
  "/portfolio": "portfolio",
  "/settings": "settings",
  "/privacy": "privacy",
  "/terms": "terms",
  "/docs": "docs",
  "/billing": "billing",
};
